import { useRouter } from 'next/router'

import styled from '@emotion/styled'
import { message } from 'antd'

import { FullWidthButton } from 'components/common/FullWidthButton'
import { postFrontRwgCart } from 'api'
import { Cookies } from 'react-cookie'
import cart from 'pages/cart'

const RWGFooterCart = ({ text, productId, quantity, cartHandler }) => {
  const router = useRouter()
  const cookies = new Cookies()
  const notLoginUserId = cookies.get('not_login_user_id')
  const token = cookies.get('token')

  const notLoginHandler = async () => {
    await postFrontRwgCart({
      not_login_user_id: notLoginUserId,
      product_id: parseInt(productId),
      quantity,
    }).then((res) => {
      if (res.status === 'success') {
        const ok = window.confirm('Would you like to go to cart?')
        if (ok) router.push('/rwg/cart')
      } else message.warning('Faild, please retry')
    })
  }

  return (
    <Container>
      <Button onClick={token ? cartHandler : notLoginHandler}>{text}</Button>
    </Container>
  )
}

export default RWGFooterCart

const Container = styled.footer`
  max-width: 480px;
  width: 100%;
  background-color: white;

  position: fixed;
  bottom: 0;
  z-index: 1;
  padding: 16px 0;
  border-top: 1px solid #eee;

  display: flex;
  justify-content: center;
  align-items: center;

  .interested {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }
`

const Button = styled(FullWidthButton)`
  width: 260px;
  height: 50px;
  margin: 0;
  background-color: #393939;
`
